import { render } from "./CharityCasesList.vue?vue&type=template&id=582ce489&scoped=true"
import script from "./CharityCasesList.vue?vue&type=script&lang=js"
export * from "./CharityCasesList.vue?vue&type=script&lang=js"

import "./CharityCasesList.vue?vue&type=style&index=0&id=582ce489&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582ce489"]])

export default __exports__